/**
 * The sidebar's numbers (spec §2). Refetched on an interval, and on realtime frames that move a
 * conversation or a task (`keysForFrame` names the key). A key the server did not answer for is
 * simply absent, and its row shows no number.
 */
import { useQuery } from "@tanstack/react-query";

import { navApi, type NavCounts } from "@/api/nav";
import { queryKeys } from "@/api/queryKeys";
import { useAuthStore } from "@/store/auth";

/** One minute: a count that lags a minute is fine; the realtime frame usually lands first. */
const REFRESH_MS = 60_000;

export function useNavCounts(): NavCounts {
  // A platform admin on the ui-kit has the shell and no agency: nothing to count, and a 403 to ask.
  const role = useAuthStore((state) => state.user?.role ?? null);
  const counts = useQuery({
    queryKey: queryKeys.nav.counts(),
    queryFn: navApi.counts,
    enabled: role !== null,
    refetchInterval: REFRESH_MS,
  });
  return counts.data ?? {};
}
